const animatedNumberInit = (block) => {
    const counters = block
        ? Array.from(block[0].querySelectorAll('.bn-animated-number'))
        : Array.from(document.querySelectorAll('.bn-animated-number'));

    if (!counters.length) return;

    counters.forEach(counter => {
        const observer = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                startCounter(counter);
                observer.disconnect();
            }
        }, { root: null, threshold: 0.1 });

        observer.observe(counter);
    });

    function startCounter(counter) {
        const counterData = counter.dataset.number;
        const stop = counterData ? parseInt(counterData, 10) : 0;
        const duration = 3000;
        const digits = counter.querySelectorAll('.bn-animated-number__number-digit');

        digits.forEach(d => d.textContent = '0');

        const startTime = performance.now();

        const updateCounter = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const eased = easeOutQuad(progress);
            const currentValue = Math.floor(stop * eased);

            const currentDigits = String(currentValue).padStart(digits.length, '0').split('');
            // Calculate how many digits are in the current value
            const numLength = String(currentValue).length;
            // Leading zeros are those before the actual number starts
            digits.forEach((digit, i) => {
                // If this digit is a leading zero (before the actual number starts), replace with space
                if (i < digits.length - String(currentValue).length && currentDigits[i] === '0') {
                    digit.textContent = '\u00A0';
                } else {
                    digit.textContent = currentDigits[i];
                }
            });
            if (progress < 1) {
                requestAnimationFrame(updateCounter);
            }
        };

        requestAnimationFrame(updateCounter);
    }

    function easeOutQuad(t) {
        return t * (2 - t);
    }

    function easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }
};


document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body'))
        animatedNumberInit();
    else if (window.acf)
        window.acf.addAction('render_block_preview/type=bn/animated-number', animatedNumberInit);
});